import request2 from '@/request/request2.js';
const interfaceApi = {
    diyUpload: '/diy/upload',
    diyBind: '/diy/bind',
    diyQuery: '/diy/query',
    diyDelete: '/diy/delete',
    diySetFile: '/diy/setFile'
};
export const diyUpload = (data) => {
    return request2.post(interfaceApi.diyUpload, data);
};
export const diyBind = (data) => {
    return request2.post(interfaceApi.diyBind, data);
};
export const diyQuery = (data) => {
    return request2.post(interfaceApi.diyQuery, data);
};
export const diyDelete = (data) => {
    return request2.post(interfaceApi.diyDelete, data);
};
export const diySetFile = (data) => {
    return request2.post(interfaceApi.diySetFile, data);
};
